import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const TermsModal: React.FC<TermsModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4">
      <div className="bg-white rounded-lg max-w-sm sm:max-w-md w-full max-h-[85vh] sm:max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-3 sm:p-4 border-b border-gray-200">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
            Condizioni di Utilizzo
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <XMarkIcon className="h-5 w-5 sm:h-6 sm:w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-3 sm:p-4 overflow-y-auto max-h-[calc(85vh-120px)] sm:max-h-[calc(90vh-140px)]">
          <div className="space-y-4">
            {/* Disclaimer */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 sm:p-4">
              <div className="flex items-start space-x-2 sm:space-x-3">
                <div className="w-5 h-5 sm:w-6 sm:h-6 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 sm:mt-1">
                  <span className="text-yellow-600 text-xs sm:text-sm">⚠️</span>
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-semibold text-yellow-800 mb-1 sm:mb-2">Disclaimer</h3>
                  <div className="text-xs sm:text-sm text-yellow-700 space-y-1 sm:space-y-2">
                    <p>
                      <strong>Attenzione:</strong> I quiz presenti in questa applicazione sono forniti a scopo informativo e di preparazione generale. 
                      Nonostante gli sforzi per garantire l'accuratezza dei contenuti, potrebbero essere presenti errori, imprecisioni o informazioni non aggiornate.
                    </p>
                    <p>
                      <strong>Nessuna responsabilità:</strong> Né Live Concorsi, né D-Serviceitalia srl, né alcun altro soggetto coinvolto nello sviluppo 
                      di questa applicazione può essere ritenuto responsabile per eventuali errori, imprecisioni o conseguenze derivanti dall'utilizzo 
                      dei quiz presenti.
                    </p>
                    <p>
                      <strong>Utilizzo a proprio rischio:</strong> L'utente si assume la piena responsabilità dell'utilizzo di questa applicazione 
                      e riconosce che nessun soggetto è perseguibile per legge per eventuali danni diretti o indiretti derivanti dall'uso dei contenuti.
                    </p>
                    <p>
                      Si raccomanda di verificare sempre le informazioni con fonti ufficiali e aggiornate prima di utilizzarle per scopi decisionali importanti.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Terms */}
            <div className="space-y-2 sm:space-y-3">
              <h3 className="text-base sm:text-lg font-semibold text-gray-900">Termini e Condizioni</h3>
              <div className="text-xs sm:text-sm text-gray-700 space-y-1 sm:space-y-2">
                <p>
                  Accedendo a questa applicazione, l'utente dichiara di aver letto, compreso e accettato integralmente 
                  le condizioni sopra esposte.
                </p>
                <p>
                  L'utilizzo dell'applicazione è riservato esclusivamente a scopi di preparazione e studio personale. 
                  È vietata la riproduzione, distribuzione o utilizzo commerciale dei contenuti senza autorizzazione.
                </p>
                <p>
                  I dati personali forniti durante la registrazione saranno trattati in conformità alla normativa 
                  sulla privacy vigente e utilizzati esclusivamente per fornire il servizio richiesto.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-center p-3 sm:p-4 border-t border-gray-200 bg-gray-50">
          <button
            onClick={onClose}
            className="px-6 sm:px-8 py-2 text-sm sm:text-base font-medium text-white bg-primary-600 border border-transparent rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
          >
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
};
